// src/urls.ts
var PLUGIN_WIDGET_PREFIX = "plugin:";
function parsePluginKeyword(keyword) {
  if (!keyword.startsWith(PLUGIN_WIDGET_PREFIX)) return null;
  const registryKey = keyword.slice(PLUGIN_WIDGET_PREFIX.length);
  if (!registryKey) return null;
  const sep = registryKey.indexOf(":");
  if (sep === -1) {
    return { pluginSlug: registryKey, widgetSlug: null, registryKey };
  }
  const pluginSlug = registryKey.slice(0, sep);
  const widgetSlug = registryKey.slice(sep + 1);
  if (!pluginSlug || !widgetSlug) return null;
  return { pluginSlug, widgetSlug, registryKey };
}
function pluginWidgetDistFile(parts, kind) {
  const base = parts.widgetSlug ?? parts.pluginSlug;
  const dir = parts.widgetSlug ? `${parts.widgetSlug}/` : "";
  const file = kind === "iife" ? `${base}.iife.js` : kind === "css" ? `${base}.css` : `${base}-ssr.umd.js`;
  return `${dir}${file}`;
}
var DEFAULT_PROXY_BASE_URL = "https://assets.homerunner.io";
function isAbsoluteUrl(url) {
  return /^https?:\/\//i.test(url);
}
function resolvePluginAssetUrl(manifestUrl, urlOrPath) {
  if (isAbsoluteUrl(urlOrPath)) return urlOrPath;
  if (!manifestUrl) {
    throw new Error(
      `Cannot resolve relative plugin asset "${urlOrPath}": manifest URL not known. Ship absolute URLs in the manifest, or pass the manifest URL when fetching.`
    );
  }
  return new URL(urlOrPath, manifestUrl).href;
}
function distRelativeAssetName(urlOrPath) {
  const clean = urlOrPath.split("#")[0].split("?")[0];
  const marker = clean.lastIndexOf("dist/");
  if (marker !== -1 && (marker === 0 || clean[marker - 1] === "/")) {
    const rel = clean.slice(marker + "dist/".length);
    if (!rel.split("/").some((segment) => /^\.+$/.test(segment))) return rel;
  }
  return extractAssetFilename(clean);
}
function extractAssetFilename(urlOrPath) {
  const noHash = urlOrPath.split("#")[0];
  const noQuery = noHash.split("?")[0];
  const segments = noQuery.split("/").filter(Boolean);
  return segments[segments.length - 1] ?? "";
}
function getPluginAssetUrl(slug, file, proxyBaseUrl = DEFAULT_PROXY_BASE_URL) {
  const base = proxyBaseUrl.endsWith("/") ? proxyBaseUrl.slice(0, -1) : proxyBaseUrl;
  return `${base}/p/${slug}/${file}`;
}

export { DEFAULT_PROXY_BASE_URL, PLUGIN_WIDGET_PREFIX, distRelativeAssetName, extractAssetFilename, getPluginAssetUrl, isAbsoluteUrl, parsePluginKeyword, pluginWidgetDistFile, resolvePluginAssetUrl };
//# sourceMappingURL=urls.js.map
//# sourceMappingURL=urls.js.map